import { markCurrentOfferBooked } from "./marketplaceSession";
import { pushMarketplaceContext } from "./pushMarketplaceContext";
import { MarketplaceContextPayload, MarketplaceHotelContextInput } from "./types";

type TenantInfoLike = {
  code?: string | null;
  name?: string | null;
} | null;

export type PushGpOfferBookMarketplaceContextInput = {
  cookieAccepted?: boolean | null;
  tenantInfo?: TenantInfoLike;
  offerCode?: string | null;
};

/**
 * Consent-gated DataLayer push for Guest Platform offer checkout Book.
 * Always uses `book_gp_offer` and includes hotel id/name + offer_code + session source fields.
 */
export const pushGpOfferBookMarketplaceContext = ({
  cookieAccepted,
  tenantInfo,
  offerCode
}: PushGpOfferBookMarketplaceContextInput): MarketplaceContextPayload | null => {
  markCurrentOfferBooked();

  const hotel: MarketplaceHotelContextInput = {
    id: tenantInfo?.code ?? null,
    name: tenantInfo?.name ?? null
  };

  return pushMarketplaceContext({
    action: "book_gp_offer",
    cookieAccepted,
    platformType: "hotel",
    hotel,
    offerCode
  });
};
